import { render } from "./Authenticated.vue?vue&type=template&id=623943ec&scoped=true"
import script from "./Authenticated.vue?vue&type=script&lang=js"
export * from "./Authenticated.vue?vue&type=script&lang=js"

import "./Authenticated.vue?vue&type=style&index=0&id=623943ec&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623943ec"]])

export default __exports__